<template>
    <!-- 添加顶部导航栏 -->
    <div class="nav-container">
        <div class="top-news-bar" @click="showDropdown = !showDropdown">
            <div class="news-marquee">
                <span class="icon">📣</span>
                <transition-group name="vertical-fade" tag="div" v-if="currentNews.length && currentNews[0]">
                    <div class="news-item" v-for="item in currentNews" :key="item._id">
                        <span class="source">{{ item.source }}:</span>
                        <span class="source">{{ item.title }}</span>
                    </div>
                </transition-group>
            </div>
            <!-- 下拉列表 -->
            <div class="news-dropdown" v-if="showDropdown">
                <div class="dropdown-item" v-for="item in newsList" :key="item._id" @click.stop="goToNews(item._id)"
                    style="cursor:pointer">
                    <span class="source">{{ item.source }}:</span>
                    <span class="source">{{ item.title }}</span>
                </div>
            </div>
        </div>
        <div class="navbar" :class="{ 'top-position': !showTopNav }">
            <div class="navbar-content">
                <div class="logo-section">
                    <div class="logo">
                        <img src="@/assets/logo.jpg" alt="九任智造">
                    </div>
                </div>

                <div class="right-section">
                    <!-- 上行：搜索框、语言选择和登录 -->
                    <div class="top-row">
                        <div class="search-box">
                            <input type="text" placeholder="搜索...">
                            <button class="search-button">
                                <el-icon>
                                    <Search />
                                </el-icon>
                            </button>
                        </div>
                        <div class="language-login">
                            <el-dropdown @command="handleLanguageChange" trigger="click" :teleported="false">
                                <el-button class="custom-language-button">
                                    {{ currentLanguage }}
                                    <el-icon class="el-icon--right"><arrow-down /></el-icon>
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item command="zh-CN">
                                            <span :class="{ 'active-language': currentLang === 'zh-CN' }">中文</span>
                                        </el-dropdown-item>
                                        <el-dropdown-item command="en-US">
                                            <span :class="{ 'active-language': currentLang === 'en-US' }">English</span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                            <div v-if="!$store.state.isLogined">
                                <div class="c_div_icon">
                                    <a href="/login">{{ $t('navbar.login') }}</a>
                                </div>
                            </div>
                            <div v-else class="user-info">
                                <div class="user-profile">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <el-avatar :src="avatarUrl" />
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item @click="handleCar">{{ $t('navbar.myCart')
                                                }}</el-dropdown-item>
                                                <el-dropdown-item @click="handleOrder">{{ $t('navbar.myOrders')
                                                }}</el-dropdown-item>
                                                <el-dropdown-item @click="handleCenter">{{ $t('navbar.accountInfo')
                                                }}</el-dropdown-item>
                                                <el-dropdown-item @click="handleLogout">{{ $t('navbar.logout')
                                                }}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                    <span class="username">{{ $store.state.userInfo.username }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 下行：导航菜单 -->
                    <div class="bottom-row">
                        <div class="nav-items">
                            <template v-for="(item, index) in navList" :key="index">
                                <div class="nav-item" :class="{ 'has-dropdown': item.children && item.children.length }"
                                    @mouseenter="handleNavHover(item)" @mouseleave="handleNavLeave">
                                    <div class="nav-link-wrapper">
                                        <a href="javascript:void(0)" @click="handleNavClick(item.link)">{{ item.name
                                        }}</a>
                                    </div>
                                    <transition name="dropdown-fade">
                                        <div v-if="item.isProduct !== true" class="dropdown-menu datacenter-dropdown"
                                            :class="{ 'show': isDropdownVisible(item) }">
                                            <div class="datacenter-container">
                                                <div class="datacenter-col" 
                                                     :class="{ 'second-col': colIdx === 1 }" 
                                                     v-for="(col, colIdx) in splitChildren(item.children)" 
                                                     :key="colIdx">
                                                    <div v-for="(node, idx) in col" :key="node._id"
                                                        class="datacenter-col-item"
                                                        @mouseenter="onDatacenterColHover(colIdx, idx, node)"
                                                        @click.prevent="handleDatacenterClick([idx + (colIdx === 1 ? col.length : 0)], node.link)">
                                                        <template v-if="node.link">
                                                            <a :href="node.link" target="_blank">{{ node.name }}</a>
                                                        </template>
                                                        <template v-else>
                                                            {{ node.name }}
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                    <transition name="dropdown-fade">
                                        <div v-if="item.isProduct === true" :class="{ 'show': isDropdownVisible(item) }"
                                            class="dropdown-menu datacenter-dropdown">
                                            <div class="datacenter-container">
                                                <template v-for="(col, colIdx) in getColumns(item, datacenterHoverPath)"
                                                    :key="colIdx">
                                                    <div class="datacenter-col">
                                                        <div v-for="(node, nodeIdx) in col" :key="nodeIdx"
                                                            class="datacenter-col-item"
                                                            :class="{ active: datacenterHoverPath[colIdx] === nodeIdx }"
                                                            @mouseenter="onDatacenterColHover(colIdx, nodeIdx, node)"
                                                            @click.prevent="handleDatacenterClick([...datacenterHoverPath.slice(0, colIdx), nodeIdx], item.link)">
                                                            <template v-if="node.link">
                                                                <a :href="node.link" target="_blank">{{ node.name }}</a>
                                                            </template>
                                                            <template v-else>
                                                                {{ node.name }}
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { computed, onMounted, onUnmounted, ref, watch, inject } from 'vue'
import config from '../../../config'
import { Menu, User, ArrowDown, Search } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n'
import global_goods_data from '../util/comm'
import axios from 'axios'

const route = useRoute()
const imagelist = ref([])
const store = useStore()
const router = useRouter()
const { t, locale } = useI18n()
const keyword = 'navbar_top'
const image_path = config[config.mode].image_path
const avatarUrl = computed(() =>
    store.state.userInfo.avatar
        ? image_path + store.state.userInfo.avatar
        : `https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png`
);
const handleLogout = () => {
    localStorage.removeItem("token")
    store.commit("changeLoginStatus", false)
    store.commit("clearUserInfo")
    router.push("/login");
}

const handleOrder = () => {
    router.push("/manager/order")
}

const handleCenter = () => {
    router.push("/center")
}

const handleCar = () => {
    router.push('/shop')
}

// 控制顶部导航栏显示
const showTopNav = ref(true)

const handleScroll = () => {
    let html_node = document.getElementById("app-root")
    if (html_node) {
        const currentScrollTop = html_node.scrollTop
        showTopNav.value = currentScrollTop == 0
    }
}

// 添加点击外部关闭下拉菜单的功能
const handleClickOutside = (event) => {
    const topNewsBar = document.querySelector('.top-news-bar')
    if (topNewsBar && !topNewsBar.contains(event.target)) {
        showDropdown.value = false
    }
}

onMounted(() => {
    // 确保页面容器可以滚动
    document.body.style.minHeight = '200vh'
    document.addEventListener('scroll', handleScroll, true)
    document.addEventListener('click', handleClickOutside)
    fetchNewsList()
    fetchNavList()
})

onUnmounted(() => {
    document.removeEventListener('scroll', handleScroll, true)
    document.removeEventListener('click', handleClickOutside)
})

const currentLang = computed(() => store.state.language)
const currentLanguage = computed(() => currentLang.value === 'zh-CN' ? '中文' : 'English')

const refreshKey = inject('refreshKey')

const handleLanguageChange = (lang) => {
    store.dispatch('changeLanguage', lang)
    locale.value = lang === 'zh-CN' ? 'zh-CN' : 'en-US'
    // 强制视图更新
    refreshKey.value++
}


// 使用计算属性获取翻译后的分类数据
const mall_categories = computed(() =>
    global_goods_data.mall.map(item => ({
        ...item,
        name: t(item.name),
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        },
        path: item.path,
        link: item.link
    }))
)

const server_categories = computed(() =>
    global_goods_data.aiService.map(item => ({
        ...item,
        name: t(item.name),
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        }
    }))
)

const product_categories = computed(() =>
    global_goods_data.product.map(item => ({
        ...item,
        name: t(item.name),
        filters: {
            industry: item.filters.industry.map(r => t(r)),
            region: item.filters.region.map(r => t(r))
        }
    }))
)

// 使用 ref 创建响应式变量
const currentMallCategory = ref({
    ...global_goods_data.mall[0],
    name: t(global_goods_data.mall[0].name),
    filters: {
        industry: global_goods_data.mall[0].filters.industry.map(r => t(r)),
        region: global_goods_data.mall[0].filters.region.map(r => t(r))
    }
})

const currentServerCategory = ref({
    ...global_goods_data.aiService[0],
    name: t(global_goods_data.aiService[0].name),
    filters: {
        industry: global_goods_data.aiService[0].filters.industry.map(r => t(r)),
        region: global_goods_data.aiService[0].filters.region.map(r => t(r))
    }
})

const currentProductCategory = ref({
    ...global_goods_data.product[0],
    name: t(global_goods_data.product[0].name),
    filters: {
        industry: global_goods_data.product[0].filters.industry.map(r => t(r)),
        region: global_goods_data.product[0].filters.region.map(r => t(r))
    }
})

// 初始化当前分类
const currentFilters = ref({
    mall: currentMallCategory.value.filters,
    aiService: currentServerCategory.value.filters,
    product: currentProductCategory.value.filters
})
// 添加hover状态跟踪
const hoveredCategories = ref({
    mall: null,
    aiService: null,
    product: null
})

const handleCategoryHover = (category, type) => {
    switch (type) {
        case 'mall':
            currentMallCategory.value = mall_categories.value.find(item => item.name === category.name)
            currentFilters.value.mall = currentMallCategory.value.filters
            hoveredCategories.value.mall = category.name
            break
        case 'aiService':
            currentServerCategory.value = server_categories.value.find(item => item.name === category.name)
            currentFilters.value.aiService = currentServerCategory.value.filters
            hoveredCategories.value.aiService = category.name
            break
        case 'product':
            currentProductCategory.value = product_categories.value.find(item => item.name === category.name)
            currentFilters.value.product = currentProductCategory.value.filters
            hoveredCategories.value.product = category.name
            break
    }
}

// 添加判断hover状态的方法
const isHovered = (category, type) => {
    return hoveredCategories.value[type] === category.name
}

// 处理筛选选项点击
const handleFilterClick = (category, filterType, value) => {
    router.push({
        path: '/mall/search/goods',
        query: {
            category: decodeURIComponent(category).replace(/\+/g, ' '),  // 解码并替换加号
            filterType: filterType,
            filterValue: value ? decodeURIComponent(value).replace(/\+/g, ' ') : undefined  // 只在 value 存在时处理
        }
    })
}

const isActive = ref(false)

const fetchNewsList = () => {
    axios.get('/webapi/news/newlist').then(res => {
        newsList.value = res.data.data // 假设返回list字段
    }).catch(error => {
        console.error('获取列表失败:', error)
    })
}

const navList = ref([])
const activeDropdown = ref(null)

// 获取导航栏数据
const fetchNavList = () => {
    axios.get('/webapi/navbar/list').then(function (response) {
        if (response.data && response.data.ActionType === 'OK') {
            navList.value = response.data.data || []
        }
    }).catch(error => {
        console.error('获取导航栏数据失败:', error)
    })
}

const handleNavClick = (link) => {
    if (!link || typeof link !== 'string' || link.trim() === '') {
        router.push('/')
    } else if (link.startsWith('/')) {
        router.push(link)
    } else {
        router.push('/' + link)
    }
}

const newsList = ref([])
const currentIndex = ref(0)
const showDropdown = ref(false)

const currentNews = computed(() => {
    if (newsList.value.length === 0) return []
    return [newsList.value[currentIndex.value]]
})

let timer = null
onMounted(() => {
    timer = setInterval(() => {
        if (newsList.value.length > 0) {
            currentIndex.value = (currentIndex.value + 1) % newsList.value.length
        }
    }, 3000)
})
onUnmounted(() => clearInterval(timer))

function goToNews(id) {
    // 关闭下拉
    showDropdown.value = false
    router.push(`/news/${id}`)
}

// 记录 hover 路径，每一层的 index
const datacenterHoverPath = ref([0])

// 获取当前 hover 路径下的节点
function getNodeByPath(children, path) {
    let node = { children }
    for (const idx of path) {
        if (!node.children || !node.children[idx]) break
        node = node.children[idx]
    }
    return node
}

// 获取每一列要显示的同级数组
function getColumns(item, path) {
    const columns = []
    let children = item.children
    for (let i = 0; i < path.length; i++) {
        columns.push(children)
        const idx = path[i]
        // 如果没有下一级，直接终止
        if (!children[idx] || !children[idx].children || children[idx].children.length === 0) {
            return columns
        }
        children = children[idx].children
    }
    // 最后一层如果还有 children 也要显示
    if (children && children.length && columns.length < path.length + 1) {
        columns.push(children)
    }
    return columns
}

function onDatacenterColHover(colIdx, nodeIdx, node) {
    // 保留前 colIdx 层，设置当前层为 nodeIdx
    datacenterHoverPath.value = datacenterHoverPath.value.slice(0, colIdx)
    datacenterHoverPath.value[colIdx] = nodeIdx
}

function handleDatacenterClick(pathArr, routerPath) {
    // 确保是绝对路径
    let path = routerPath.startsWith('/') ? routerPath : '/' + routerPath
    router.push({
        path: path,
        query: {
            path: pathArr.join(',')
        }
    })
}

const isDropdownVisible = (item) => {
    return activeDropdown.value === item
}

const handleNavHover = (item) => {
    activeDropdown.value = item
}

const handleNavLeave = () => {
    activeDropdown.value = null
}

function splitChildren(children) {
    if (!children) return [[]]
    if (children.length > 20) {
        const mid = Math.ceil(children.length / 2)
        return [children.slice(0, mid), children.slice(mid)]
    }
    return [children]
}

</script>


<style lang="scss" scoped>
.nav-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1001;
}

.c_div_icon {
    margin-left: 10px;

    a {
        font-size: 16px;
        color: #ffffff;
        text-decoration: none;
        font-weight: 500;
    }
}

.user-profile {
    display: flex;
    align-items: center;
}

.username {
    margin-left: 10px;
}

.navbar {
    width: 100%;
    margin: 0 auto;
    background: #233D9C;
    /* 深蓝色背景 */
    position: relative;
    z-index: 1000;
    transition: transform 0.3s ease;

    &.top-position {
        transform: translateY(-50px);
    }
}

.navbar-content {
    display: flex;
    align-items: center;
    max-width: 1500px;
    width: 100%;
    margin: 0 auto;
    height: 100px;
    /* 增加高度适应两行 */
    padding: 0 20px;
}

.logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    width: 150px;
    height: 100%;
}

.logo {
    width: 90px;
    height: 90px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.company-name {
    font-size: 20px;
    font-weight: bold;
    color: white;
}

.right-section {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
}

.top-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 10px;
    height: 60px;
}

.bottom-row {
    display: flex;
    align-items: center;
    height: 50px;
}

.nav-items {
    display: flex;
    height: 100%;
    white-space: nowrap;
    align-items: center;
    gap: 10px;
}

.nav-item {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 100%;
    background-color: #233D9C;
    cursor: pointer;
    white-space: nowrap;

    .nav-link-wrapper {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;

        &::after {
            content: '';
            position: absolute;
            bottom: 0.125vw;
            left: 0;
            width: 100%;
            height: 0.125vw;
            background-color: #ffffff;
            transform: scaleX(0);
            transition: transform 0.3s ease;
        }
    }

    &:hover .nav-link-wrapper::after {
        transform: scaleX(1);
    }

    a {
        font-size: 18px;
        color: #ffffff;
        text-decoration: none;
        font-weight: 500;
    }
}

.search-box {
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 20px;
    height: 100%;

    input {
        width: 200px;
        height: 36px;
        font-size: 16px;
        border-radius: 18px;
        border: none;
        padding: 0 40px 0 15px;
        background-color: white;
    }

    .search-button {
        position: absolute;
        right: 5px;
        top: 50%;
        font-size: 16px;
        transform: translateY(-50%);
        background: none;
        border: none;
        color: #333;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.language-login {
    display: flex;
    align-items: center;
    color: white;
    font-size: 16px;
    flex-direction: row;

    .language-selector,
    .login-link {
        margin-left: 15px;
        cursor: pointer;
    }
}

.submenu-container,
.product-submenu-container {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    border-top: 1px solid #f0f0f0;
}

.submenu-container {
    min-width: 200px;
}

.product-submenu-container {
    width: 100%;
}

.nav-item:hover .submenu-container,
.nav-item:hover .product-submenu-container {
    display: block;
}

.category-item {
    color: #333;
    padding: 10px 15px;

    &:hover {
        background-color: #f5f7fa;
    }
}

/* 保留子菜单的其他样式 */
.active-language {
    color: #233D9C;
    font-weight: bold;
}

.el-dropdown {
    margin-left: 10px;
}

.el-button {
    display: flex;
    align-items: center;
    gap: 4px;
}

.custom-language-button {
    background-color: #4055A8;
    border-color: transparent;
    color: white;

    &:hover,
    &:focus {
        background-color: #5367C3;
        border-color: transparent;
        color: white;
    }
}

/* 添加焦点样式 */
.el-dropdown-item:focus {
    outline: 2px solid #409EFF;
    outline-offset: -2px;
}

/* 确保下拉菜单在焦点时可见 */
.el-dropdown-menu {
    visibility: visible !important;
}

.submenu-filters {
    padding: 10px;
    display: flex;
    gap: 10px;

    .el-select {
        width: 150px;
    }
}

:deep(.el-sub-menu) {
    .el-sub-menu__title {
        height: 40px;
        line-height: 40px;
    }
}

:deep(.el-menu--horizontal) {
    .el-sub-menu__title {
        border-bottom: none;
    }

    .el-menu-item {
        height: auto;
        line-height: normal;
    }
}

/* 悬停效果 */
:deep(.el-menu-item):hover,
:deep(.el-sub-menu__title):hover {
    background-color: #f5f7fa;
}

/* 下拉菜单样式 */
:deep(.el-menu--popup) {
    min-width: 200px;
    padding: 5px 0;
}

.banner-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    height: 100%;
}

.banner-item {
    flex: 1;
    height: 100%;
    min-width: 300px;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.banner-link {
    display: block;
    width: 100%;
    height: 100%;
}

.banner-image {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    transition: transform 0.3s ease;
}

.banner-image:hover {
    transform: scale(1.05);
}

.nav-item.has-dropdown {
    position: static;

    &:hover .dropdown-menu {
        display: block;
    }
}

.dropdown-menu {
    margin: 0 auto;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: -100;
    padding: 10px 0;
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: top;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
    opacity: 0;
    transform: scaleY(0.6);
}

.dropdown-fade-enter-to,
.dropdown-fade-leave-from {
    opacity: 1;
    transform: scaleY(1);
}

.top-news-bar {
    position: relative;
    background: linear-gradient(90deg, #1a1a1a 0%, #2d2d2d 100%);
    color: #fff;
    align-items: center;
    height: 40px;
    padding: 0 24px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(90deg, #2d2d2d 0%, #3d3d3d 100%);
    }

    .icon {
        display: flex;
        font-size: 20px;
        margin-right: 12px;
        align-items: center;
        animation: bounce 2s infinite;
    }

    .news-marquee {
        display: flex;
        flex: 1;
        overflow: hidden;
        height: 40px;

        .news-item {
            white-space: nowrap;
            font-size: 15px;
            line-height: 40px;
            align-items: center;

            .source {
                color: #ffd700;
                margin-right: 6px;
                font-weight: 500;
            }
        }
    }

    .news-dropdown {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100vw;
        background: rgba(24, 24, 24, 0.95);
        backdrop-filter: blur(10px);
        color: #fff;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        z-index: 9999;
        max-height: 60vh;
        overflow-y: auto;
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        .dropdown-item {
            padding: 14px 24px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            font-size: 15px;
            transition: all 0.3s ease;

            .source {
                color: #ffd700;
                margin-right: 6px;
                font-weight: 500;
            }

            &:hover {
                background: rgba(255, 255, 255, 0.1);
                padding-left: 28px;
            }
        }
    }
}

@keyframes bounce {

    0%,
    20%,
    50%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-3px);
    }

    60% {
        transform: translateY(-2px);
    }
}

.vertical-fade-enter-active,
.vertical-fade-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.vertical-fade-enter-from {
    transform: translateY(40px);
    opacity: 0;
}

.vertical-fade-enter-to {
    transform: translateY(0);
    opacity: 1;
}

.vertical-fade-leave-from {
    transform: translateY(0);
    opacity: 1;
}

.vertical-fade-leave-to {
    transform: translateY(-40px);
    opacity: 0;
}

.datacenter-dropdown {
    min-width: 900px;
    display: none;
    padding: 0;

    .datacenter-container {
        display: flex;
        width: 100%;
    }

    .datacenter-col {
        min-width: 180px;
        background: #fff;
        border-left: 1px solid #e6eaf7;

        &:first-child {
            background: #233D9C;
            color: #fff;
            border-left: none;

            .datacenter-col-item {
                padding: 10px 16px;
            }
        }

        .datacenter-col-item {
            padding: 10px 16px;
            cursor: pointer;
            font-size: 12px;
            transition: background 0.2s, color 0.2s;

            &.active,
            &:hover {
                background: #4055A8;
                color: #fff;
            }

            a {
                color: inherit;
                font-size: 12px;
                text-decoration: none;
            }
        }
    }
}

.datacenter-col.second-col {
    background: #233D9C;
    color: #fff;
    border-right: none;
}

.datacenter-col.second-col .datacenter-col-item {
    color: #ffffff;
}

.datacenter-col.second-col .datacenter-col-item a {
    color: #ffffff;
}
</style>
